import {Loader2Icon} from 'lucide-react'

function CustomLoader({size, color}) {
  return (
    <>
        <div className='w-full h-full flex items-center justify-center'>
            <Loader2Icon className={`w-${size} h-${size} animate-spin text-[${color}]`}/>
        </div>
    </>
  )
}

export default CustomLoader